import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../base/base-service';
import { Observable } from 'rxjs';
import { API_CONSTANTS } from '../../base/api-constants';


@Injectable({
  providedIn: 'root'
})
export class PackagesService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  GetAllInterviews(pageNumber: number, packageId?: number | null): Observable<any> {
    let params: HttpParams | undefined;
    if (packageId != null && packageId !== undefined) {
      params = new HttpParams().set('packageId', packageId.toString());
    }
    return this.get(API_CONSTANTS.Packages.GetAllInterviews + pageNumber, params);
  }

  GetAllCVs(pageNumber: number, status?: number | null, packageId?: number | null): Observable<any> {
    let params = new HttpParams();
    if (status != null && status !== undefined) {
      params = params.set('status', status.toString());
    }
    if (packageId != null && packageId !== undefined) {
      params = params.set('packageId', packageId.toString());
    }
    return this.get(
      API_CONSTANTS.Packages.GetAllCVs + pageNumber,
      params.keys().length ? params : undefined
    );
  }

  GetAllWorkshops(pageNumber: number, status?: number | null, packageId?: number | null): Observable<any> {
    let params = new HttpParams();
    if (status != null && status !== undefined) {
      params = params.set('status', status.toString());
    }
    if (packageId != null && packageId !== undefined) {
      params = params.set('packageId', packageId.toString());
    }
    return this.get(
      API_CONSTANTS.Packages.GetAllWorkshops + pageNumber,
      params.keys().length ? params : undefined
    );
  }

  UpdateCV(model: any): Observable<any> {
    return this.post_formData(API_CONSTANTS.Packages.UpdateCV, model);
  }

  UpdateWorkshop(model: any): Observable<any> {
    return this.post_formData(API_CONSTANTS.Packages.UpdateWorkshop, model);
  }
  ProceedWithInterview(packaceId: any): Observable<any> {
    return this.get(API_CONSTANTS.Packages.ProceedWithInterview + packaceId);
  }

  ProceedWithWorkshop(packageId: any): Observable<any> {
    return this.get(API_CONSTANTS.Packages.ProceedWithWorkshop + packageId);
  }

  ProceedWithCV(packageId: any): Observable<any> {
    return this.get(API_CONSTANTS.Packages.ProceedWithCV + packageId);
  }

  GetProcessOrders(
    pageNumber: number,
    pageSize: number = 20,
    processStatus?: number | null,
    packageDefinitionCode?: string | null,
    slaOverdue?: boolean | null
  ): Observable<any> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    if (processStatus != null && processStatus !== undefined) {
      params = params.set('processStatus', processStatus.toString());
    }
    if (packageDefinitionCode) {
      params = params.set('packageDefinitionCode', packageDefinitionCode);
    }
    if (slaOverdue === true) {
      params = params.set('slaOverdue', 'true');
    }
    return this.get(API_CONSTANTS.Packages.GetProcessOrders, params);
  }

  GetProcessOrder(orderId: number | string): Observable<any> {
    return this.get(API_CONSTANTS.Packages.GetProcessOrder + orderId);
  }

  CopyAllProcessData(orderId: number | string): Observable<any> {
    return this.get(API_CONSTANTS.Packages.CopyAllProcessData + orderId);
  }

  UpdateProcessStatus(orderId: number | string, processStatus: number): Observable<any> {
    return this.put(API_CONSTANTS.Packages.UpdateProcessStatus + orderId, {
      processStatus,
    });
  }

}
